import axios from 'axios';

// If REACT_APP_API_BASE_URL is set (e.g. https://api.example.com), use it.
// Otherwise return relative paths so the app can call /api/... (works with CRA proxy or same-origin).
export const API_BASE = process.env.REACT_APP_API_BASE_URL || '';

export const apiUrl = (path = '') => {
  if (!path) return API_BASE || '';
  // Ensure path starts with '/'
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (!API_BASE) return normalized;
  // Trim trailing slash from base and join
  return `${API_BASE.replace(/\/$/, '')}${normalized}`;
};

export const api = axios.create({ baseURL: API_BASE || undefined });

export default api;
